import { inject, needs, NetworkException } from "fw";
import { ResetPasswordForm, ResetUserPasswordAction } from "forms/reset-password";
import { PasswordStrengthMeter } from "views/components/password-strength-meter";
import { dispatch } from "fw-state";
import { LogoutAction } from "state/actions";

@inject
@needs(PasswordStrengthMeter)
export class ResetPassword {
    public resetPasswordForm = new ResetPasswordForm();
    public isResetting: boolean = false;
    public isDone: boolean = false;
    public hasError: boolean = false;
    private resetToken: string = null;

    public constructor() {}

    public async activate(params: { token: string }) {
        this.resetToken = params.token;
        await dispatch(new LogoutAction("", false));
    }

    public async save() {
        try {
            this.isResetting = true;
            await dispatch(new ResetUserPasswordAction(this.resetPasswordForm, this.resetToken));
            this.isDone = true;
        } catch (err) {
            if (err instanceof NetworkException) {
                switch (err.result.Code) {
                    case "NOTFOUND":
                        this.hasError = true;
                        break;
                    case "BADREQUEST":
                        this.resetPasswordForm.isInvalid = true;
                        this.resetPasswordForm.validationMessages = [err.result.Message];
                        break;
                }
            }
        } finally {
            this.isResetting = false;
        }
    }
}
